import React from "react";
import OISMain from "./OISMain";

const OISMainContainer = (props) => {
  return <OISMain />;
};

export default OISMainContainer;
